import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";
import Link from "next/link";

interface ContactInfoCardProps {
    title: string;
    value: string;
    icon: LucideIcon | React.ElementType;
    href?: string;
    className?: string;
}

export const ContactInfoCard = ({
    title,
    value,
    icon: Icon,
    href,
    className,
}: ContactInfoCardProps) => {
    const content = (
        <div className={cn("bg-white p-8 rounded-xl shadow-sm border border-gray-50 flex flex-col items-start gap-4 h-full hover:shadow-md transition-shadow", className)}>
            <div className="w-12 h-12 rounded-lg bg-primary-50 flex items-center justify-center text-primary-600">
                <Icon className="w-6 h-6" />
            </div>
            <div>
                <h3 className="font-brastika text-xl text-primary-900 mb-1">{title}</h3>
                <p className="text-primary-600 font-medium break-all">{value}</p>
            </div>
        </div>
    );

    if (href) {
        return (
            <Link href={href} className="block group">
                {content}
            </Link>
        );
    }

    return content;
};

export const QuoteRequestCard = ({ className }: { className?: string }) => {
    return (
        <div className={cn("bg-[#5F3F1C] p-10 rounded-2xl text-white flex flex-col items-center text-center gap-6", className)}>
            <h3 className="font-brastika text-3xl md:text-4xl">Demande de Devis</h3>
            <p className="text-white/80 max-w-xs text-sm leading-relaxed">
                Pour les commandes professionnelles ou les coffrets cadeaux d&apos;entreprise, veuillez remplir notre formulaire dédié.
            </p>
            <button className="w-full bg-white text-[#5F3F1C] px-8 py-4 rounded-xl font-bold uppercase text-xs tracking-widest hover:bg-white/90 transition-colors mt-4">
                Accéder au formulaire
            </button>
        </div>
    );
};
